import Helper from '@ember/component/helper';
import { type Registry as Services, service } from '@ember/service';

interface TopSearchingCountriesFormatHelperSignature {
  Args: {
    Positional: [string[]?];
  };
  Return: string;
}

export default class TopSearchingCountriesFormatHelper extends Helper<TopSearchingCountriesFormatHelperSignature> {
  @service declare intl: Services['intl'];

  compute([
    topCountries,
  ]: TopSearchingCountriesFormatHelperSignature['Args']['Positional']): TopSearchingCountriesFormatHelperSignature['Return'] {
    if (!topCountries || topCountries.length === 0) {
      return this.intl.t('general.missing');
    }

    const limitedTopCountries = topCountries.slice(0, 3);
    let topCountriesString = limitedTopCountries.join(', ');

    if (topCountries.length > 3) {
      topCountriesString += ', ...';
    }

    return topCountriesString;
  }
}
